export interface MaskOptions {
  type?: 'phone' | 'email' | 'custom' | 'auto'
  keepStart?: number
  keepEnd?: number
  maskChar?: string
  customPattern?: RegExp
  emptyPlaceholder?: string
}

export const maskSensitive = (value: any, options: MaskOptions = {}): string => {
  const {
    type = 'auto',
    keepStart = 3,
    keepEnd = 2,
    maskChar = '*',
    customPattern,
    emptyPlaceholder = '--',
  } = options

  if (value == null || value === '' || value === undefined) return emptyPlaceholder

  const stringValue = String(value).trim()
  if (!stringValue) return emptyPlaceholder

  if (type === 'custom' && customPattern) {
    return stringValue.replace(customPattern, (match) => maskChar.repeat(match.length))
  }

  if (type === 'phone' || (type === 'auto' && /^[\+]?\d{7,15}$/.test(stringValue))) {
    if (/^[\+]?\d{7,15}$/.test(stringValue)) {
      return stringValue.replace(/(\d{3})\d+(\d{4})/, `$1${maskChar.repeat(4)}$2`)
    }
  }

  if (type === 'email' || (type === 'auto' && /^[^@]+@[^@]+$/.test(stringValue))) {
    const [local, domain] = stringValue.split('@')
    if (local.length <= 2) return local[0] + maskChar + '@' + domain
    const keepStartLocal = 2
    const keepEndLocal = 1
    const maskLength = Math.max(1, local.length - keepStartLocal - keepEndLocal)
    const maskedLocal =
      local.slice(0, keepStartLocal) + maskChar.repeat(maskLength) + local.slice(-keepEndLocal)
    return maskedLocal + '@' + domain
  }

  if (stringValue.length <= keepStart + keepEnd) {
    return stringValue[0] + maskChar.repeat(stringValue.length - 1)
  }

  const maskLength = stringValue.length - keepStart - keepEnd
  return stringValue.slice(0, keepStart) + maskChar.repeat(maskLength) + stringValue.slice(-keepEnd)
}

export default maskSensitive
